import React, { useCallback, useEffect, useState } from 'react';
import { Card, Badge, Spinner, Alert, InputGroup, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { helpdeskAPI } from '../services/api';

const KnowledgeBase = () => {
  const navigate = useNavigate();
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState('');

  const fetchEntries = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const params = search ? { search } : {};
      const response = await helpdeskAPI.getKnowledgeEntries(params);
      setEntries(response.data.results || response.data || []);
    } catch (err) {
      console.error('Error loading knowledge base:', err);
      setError('Failed to load the knowledge base');
    } finally {
      setLoading(false);
    }
  }, [search]);

  useEffect(() => {
    const timeout = setTimeout(fetchEntries, 250);
    return () => clearTimeout(timeout);
  }, [fetchEntries]);

  return (
    <div className="main-content">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>
          <i className="fas fa-book me-2"></i>
          Knowledge Base
        </h2>
      </div>

      {error && <Alert variant="danger">{error}</Alert>}

      <Card className="mb-4">
        <Card.Body>
          <InputGroup>
            <InputGroup.Text>
              <i className="fas fa-search"></i>
            </InputGroup.Text>
            <Form.Control
              type="text"
              placeholder="Search question, answer, or tag..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </InputGroup>
        </Card.Body>
      </Card>

      {loading ? (
        <div className="text-center py-5">
          <Spinner animation="border" role="status" className="me-2" />
          <span>Loading knowledge base...</span>
        </div>
      ) : entries.length === 0 ? (
        <Card>
          <Card.Body className="text-center text-muted py-5">
            <i className="fas fa-lightbulb display-1 mb-3"></i>
            <h3>No knowledge entries yet</h3>
            <p>Entries saved from ticket replies will show up here.</p>
          </Card.Body>
        </Card>
      ) : (
        <div className="d-grid gap-3">
          {entries.map((entry) => (
            <Card key={entry.id}>
              <Card.Body>
                <div className="d-flex justify-content-between align-items-start gap-2 mb-2">
                  <strong>{entry.question_summary}</strong>
                  {entry.category_tag && <Badge bg="secondary">{entry.category_tag}</Badge>}
                </div>
                <p className="mb-2" style={{ whiteSpace: 'pre-wrap' }}>{entry.answer}</p>
                <small className="text-muted">
                  {entry.created_by_name || 'Unknown'} &middot; {new Date(entry.created_at).toLocaleDateString()}
                  {entry.source_ticket && (
                    <>
                      {' '}
                      &middot;{' '}
                      <button
                        type="button"
                        className="btn btn-link btn-sm p-0 align-baseline"
                        onClick={() => navigate(`/tickets/${entry.source_ticket}`)}
                      >
                        #{entry.source_ticket_number || 'source ticket'}
                      </button>
                    </>
                  )}
                </small>
              </Card.Body>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default KnowledgeBase;
